<template>
  <div v-if="this.riseupGoal >= 0" class="riseupGoal card-box container-padding">
    <div class="container-padding">
      <div class="goal">יעד riseup</div>
      <div class="title">
        <div>כמה כסף ישאר בסוף {{this.monthName}}?</div>
      </div>
      <div class="value">
        {{this.formattedRiseupGoal}} ₪
      </div>
      <div class="disclaimer">
        <img class="notice-icon" :src="require('@/assets/icons/exclemation-mark-gray.svg')">
        <span v-if="hasRemainingVariables">אם תעמדו ביעד ההוצאות המשתנות</span>
        <span v-else>אם לא תוציאו עוד הוצאות משתנות</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moneyUtils from '../../../../../../../../utils/money';

export default {
  name: 'RiseupGoal',
  computed: {
    ...mapGetters('cashflowView', ['monthName', 'riseupGoal', 'remainingVariables']),
    formattedRiseupGoal() {
      return moneyUtils.formatAmountWithFraction(this.riseupGoal, 0);
    },
    hasRemainingVariables() {
      return this.remainingVariables > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .riseupGoal {
    margin-bottom: 16px;

    .container-padding {
      padding: 18px;
    }

    .goal {
      color: $riseup_gray_2;
      font-size: 10px;
      font-weight: bold;
    }

    .title {
      color: $riseup_gray_2;
      font-family: GretaSans;
      font-size: 24px;
      font-weight: bold;
      margin: 4px 0 22px;
    }

    .value {
      font-family: SimplerPro;
      font-size: 46px;
      line-height: 32px;
      margin: 0 0 18px;
      color: $riseup_gray_2;
    }

    .disclaimer {
      color: $riseup_gray_2;
      font-size: 16px;

      .notice-icon {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/out-of-date-month/components/RiseupGoal.vue